export default "__VITE_ASSET__DgYvwjAs__"